/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var MakeReadyStatus;
(function (MakeReadyStatus) {
    MakeReadyStatus["READY"] = "Ready";
    MakeReadyStatus["NOT_READY"] = "Not Ready";
})(MakeReadyStatus || (MakeReadyStatus = {}));
